import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../components/button/ButtonPrimary";

const DeleteUser = (props) => {
  const { deletePopup, setDeletePopup, deleteUser, id, isDeactivated } = props;
  console.log("called delete");

  const handleDelete = () => {
    deleteUser(id);
    setDeletePopup(false);
  };

  return (
    deletePopup && (
      <>
        <div className="new-user-delete-popup">
          <div className="bg-dark" />
          <div className="popup-card">
            <CloseIcon
              className="cross"
              onClick={() => setDeletePopup(false)}
            />

            <p className="popup-title">
              {isDeactivated ? "Are you sure you want to activate this user?" : 
              "Are you sure you want to deactivate this user?" }
            </p>
            <div className="save-actions">
              <div />
              <div className="flex">
                <ButtonPrimary
                  text="Cancel"
                  onClick={() => setDeletePopup(false)}
                  className="mr-2 grey"
                  outline
                />
                <ButtonPrimary text="Confirm" onClick={handleDelete} />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default DeleteUser;
